import React, { PureComponent } from 'react';
import { ServiceBlockContainer } from './index';
import MenuBlock from 'blocks/menublock';
import VideoBlock from 'blocks/videoblock';
import ParallaxBlock from 'blocks/parallaxblock';
import TextBlock from 'blocks/textblock';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import OPE from 'components/common/EpiOnPageEdit';
import { BLOCKS } from 'constants/blockTypes';
import CountyContentAreaBlock from '../../blocks/countycontentareablock';
import { setMetaTags as utilsSetMetaTags } from '../../utils';

class ServiceBlock extends PureComponent {
  getBlocks = () => {
    const { contentarea } = this.props;
    if (!contentarea || !contentarea.length) return null;
    if (contentarea.length === 1) {
      contentarea[0].serviceMetaTitle &&
        utilsSetMetaTags(`property="og:title"`, contentarea[0].serviceMetaTitle);
      contentarea[0].serviceMetaDescription &&
        utilsSetMetaTags(`property="og:description"`, contentarea[0].serviceMetaDescription);
      contentarea[0].serviceMetaKeywords &&
        utilsSetMetaTags(`property="og:keywords"`, contentarea[0].serviceMetaKeywords);
      contentarea[0].serviceMetaKeywords &&
        utilsSetMetaTags(`property="keywords"`, contentarea[0].serviceMetaKeywords);
      contentarea[0].serviceMetaImage &&
        utilsSetMetaTags(
          `property="og:image"`,
          `${window.location.protocol}//${window.location.hostname}${
            contentarea[0].serviceMetaImage
          }`
        );
      contentarea[0].serviceMetaTitle && (document.title = contentarea[0].serviceMetaTitle);
    }
    const blocks = contentarea.map((block, i) => {
      return this.getBlockAsComponent(block, `${i}`);
    });

    return blocks;
  };

  getBlockAsComponent = (props, key) => {
    let block;
    switch (props.blockType) {
      case BLOCKS.PARALLAX_BLOCK:
        if (this.props.subMenuMobile) {
          block = (
            <ParallaxBlock
              key={key}
              subMenuMobile={this.props.subMenuMobile}
              opacity={this.props.opacity}
              {...props}
            />
          );
        } else {
          block = <ParallaxBlock key={key} opacity={this.props.opacity} {...props} />;
        }
        break;
      case BLOCKS.TEXT_BLOCK:
        block = <TextBlock key={key} subMenuMobile={this.props.subMenuMobile} {...props} />;
        break;
      case BLOCKS.MENU_BLOCK:
        if (this.props.showMenuBlock) {
          block = <MenuBlock key={key} {...props} />;
        }
        break;
      case BLOCKS.VIDEO_BLOCK:
        block = <VideoBlock key={key} {...props} />;
        break;
      case BLOCKS.COUNTY_CONTENT_AREA_BLOCK:
        block = (
          <CountyContentAreaBlock
            key={key}
            showMenuBlock={this.props.showMenuBlock}
            opacity={this.props.opacity}
            {...props}
          />
        );
        break;
      default:
        break;
    }

    return block ? block : null;
  };

  render() {
    const blocks = this.getBlocks();
    const { blockName } = this.props;

    return (
      <OPE propertyName={blockName}>
        {<ServiceBlockContainer>{blocks && blocks}</ServiceBlockContainer>}
      </OPE>
    );
  }
}

const mapStateToProps = state => ({
  filter: {
    current: state.filter.filter,
    loading: state.filter.loading
  }
});

export default connect(mapStateToProps)(ServiceBlock);

ServiceBlock.propTypes = {
  blockName: PropTypes.string.isRequired,
  nopadding: PropTypes.bool,
  nomargin: PropTypes.bool,
  contentarea: PropTypes.any
};
